var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliticaNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.61 48.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fa0073;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .99px;\n      }\n\n      .cls-2 {\n        fill: #fa0073;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        font-family: Garnett-Semibold, Garnett;\n        font-size: 3.06px;\n        font-weight: 600;\n      }\n\n      .cls-4 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-7 {\n        letter-spacing: -.05em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.06 12.29 29.06 17.15 34.03 17.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.03,36.28c0,.48-.39.87-.87.87H15.9c-.48,0-.87-.4-.87-.87V13.17c0-.48.39-.88.87-.88h13.71c.23,0,.34.1.5.26l3.66,3.57c.17.16.26.39.26.62v19.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.72,
    y1: 24.18,
    x2: 19.72,
    y2: 24.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.72,
    y1: 28.18,
    x2: 19.72,
    y2: 28.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.72,
    y1: 32.18,
    x2: 19.72,
    y2: 32.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.85,
    y1: 20.17,
    x2: 19.6,
    y2: 20.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.9,16.02c-.5,0-.91.41-.91.91v23.24c0,.5.41.91.91.91h18.84c.5,0,.91-.41.91-.91"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34.03 8.5 36.5 6.55 37.34 9.58 40.49 9.45 39.39 12.4 42.01 14.14 39.39 15.88 40.49 18.83 37.34 18.7 36.5 21.73 34.03 19.78 31.56 21.73 30.71 18.7 27.57 18.83 28.67 15.88 26.05 14.14 28.67 12.4 27.57 9.45 30.71 9.58 31.56 6.55 34.03 8.5"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(29.17 15.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "Nu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 4.31,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 6.09,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 7.82,
    y: 0
  }, "o")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticaNew);
export default __webpack_public_path__ + "static/media/politicaNew.d9f6f5e8ecd3fc95dc44266c173009db.svg";
export { ForwardRef as ReactComponent };